import React, { Component } from 'react';
import { routerShape } from 'react-router';
import { connect } from 'react-redux';
import MessageList from './MessageList'
import { addErrorMessage } from '../action-creators/add-message'
import clearMessages from '../action-creators/clear-messages'
import authoriseWithCFToken from '../helpers/authoriseWithCFToken';
import createSmeRedirectUrl from '../helpers/createSmeRedirectUrl';
import codifyUrlStateParams from '../helpers/codifyURLStateParams';
import saveUriState from '../action-creators/save-uri-state'
import userSmall from '../../images/user_small.svg'
import configHandler from '../configHandler';

const generateCFToken = (userName, password) => encodeURIComponent(btoa(`${userName}:${password}`));
const redirectTo = urlPath => window.location = urlPath;

class CompanyFileLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: '',
      password: ''
    };
  }

  getQueryString() {
    const location = this.props.location;
    return location.query;
  }

  componentWillMount() {
    const state = this.getQueryString().state;
    if (!state) {
      this.context.router.push('/notfound');
    }

    const decodedState = codifyUrlStateParams.decode(state);
    this.props.saveUriStateToStore(decodedState);
    this.setState({...this.state, companyFilename: decodedState.companyFilename});
  }

  login(event) {
    event.preventDefault();
    const cfToken = generateCFToken(this.state.user, this.state.password)
    const config = configHandler();
    const publicApiUri = config.TAXONLINE_PUBLIC_API_URL;

    authoriseWithCFToken(cfToken, this.getQueryString().state, publicApiUri)
      .then(response => {
        return response.json().then(body => {
          return createSmeRedirectUrl(this.getQueryString().state, body.uid);
        });
      })
      .then(redirectTo)
      .catch(err => {
        this.props.addErrorMessage(err.message);
      });
  }

  handleChange(prop, event) {
    this.props.clearMessages();
    this.setState({ [prop]: event.target.value });
  }

  render() {
    return (
      <main className="cfl">
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-offset-7 col-md-10">
                <h3 className="hero text-center text-light">Sign on to company file</h3>
                <div className="panel panel-default">
                  <div className="panel-body">
                    <MessageList />
                    <h4 className="flush-top"><img className="icon" src={userSmall} /> {this.state.companyFilename}</h4>
                    <p className="text-muted">
                      <small>You’ve just signed in with your my.MYOB login – now you need to sign on to your company file. Use the company file <strong>user ID</strong> and <strong>password</strong> that you use in AccountRight to sign on to this company file.</small>
                    </p>
                    <hr/>
                    <form role="form" autoComplete="off" noValidate="novalidate">
                      <div className="form-group">
                        <label htmlFor="UserId">User ID</label>
                        <input name="UserId"
                               className="form-control"
                               type="text"
                               value={this.state.user}
                               onChange={this.handleChange.bind(this, 'user')}
                               autoFocus
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="Password">Password</label>
                        <input name="Password"
                               className="form-control"
                               type="password"
                               value={this.state.password}
                               onChange={this.handleChange.bind(this, 'password')} />
                      </div>
                      <button className="btn btn-block btn-primary" type="submit" onClick={this.login.bind(this)}>Sign on</button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </section>
      </main>
    );
  }
}

CompanyFileLogin.propTypes = {
  saveUriStateToStore: React.PropTypes.func,
  clearMessages: React.PropTypes.func,
  addErrorMessage: React.PropTypes.func,
  location: React.PropTypes.object
};

CompanyFileLogin.contextTypes = {
  router: routerShape.isRequired
};

export default connect(
    () => ({}),
    dispatch => ({
      saveUriStateToStore: state => dispatch(saveUriState(state)),
      clearMessages: () => dispatch(clearMessages()),
      addErrorMessage: message => dispatch(addErrorMessage(message))
    }))(CompanyFileLogin);



// WEBPACK FOOTER //
// ./src/app/components/CompanyFileLogin.js